import { formatResponseData, otherQueryList } from '@/services/adsenseDisplay'

const adsenseDisplayModel = {
    namespace: 'adsenseDisplay',
    state: {
        resourceList: [],
        loading: true,
    },
    effects: {
        *queryResourceList({ payload }, { call, put }) {
            const values = {
                ...(payload || {}),
            }
            let formatList = {}

            // 请求失败，直接用第三方接口获取资源位
            formatList = yield call(otherQueryList, values)

            const formatData = formatResponseData(formatList)
            yield put({
                type: 'update',
                payload: {
                    resourceList: formatData || [],
                    loading: false,
                },
            })
        },
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default adsenseDisplayModel
